import { UserDto } from '../../../../auth/user.dto';
import { DisplayLabel } from '../../../../shared/models/displayLabel';
import { MaritalStatus } from '../../../../shared/models/enums/marital-status.enum';
import { Nationality } from '../../../../shared/models/enums/nationality.enum';
import { ResidentialStatus } from '../../../../shared/models/enums/residential-status.enum';
import { SurveyFSEDto } from '../../fse/surveyFSEDto';
import {
  AssessmentActivity,
  AssessmentContext,
  AssessmentContractTypes,
  AssessmentHowLongHasWorked,
  AssessmentJobCenterRegistration,
  AssessmentStatus,
  AssessmentSupportProposal,
  AssessmentUnactivity,
  AssessmentWorkingTime,
} from '../assessment.enums';
import { AssessmentChildDto } from './assessment-child.dto';
import { AssessmentFormationDto } from './assessment-formation.dto';
import { AssessmentJobSoughtDto } from './assessment-job-sought.dto';
import { AssessmentProExpDto } from './assessment-pro-exp.dto';
import { AssessmentTransportModeDto } from './assessment-transport-mode.dto';

export class AssessmentDto {
  public id: number;
  public beneficiaryId: number;
  public creatorUser: UserDto;
  public creationDateInterview: string;
  public updateStatusDate: string;
  public status: AssessmentStatus;
  public context: AssessmentContext;
  public generatedSurveyFse: SurveyFSEDto;

  // *********************************************************************************************
  // * Detail

  nationality: Nationality;
  validIdentityDocument: boolean;
  renewalInProgress: boolean;
  renewalHelpNeeded: boolean;
  address: string;
  additionalAddress: string;
  city: string;
  postalCode: string;
  qpvId: number;

  maritalStatus: MaritalStatus;
  singleParent: boolean;
  partnerName: string;
  partnerSituation: string;

  childrenCount: number;
  children: AssessmentChildDto[] = [];
  childInProgress: boolean;
  isHelper: boolean;
  foreignParents: 'true' | 'false' | 'unknown';
  familyBarriers: string;

  // *********************************************************************************************
  // * Global situation

  claimRsaInsufRes: boolean;
  claimRsaNoRes: boolean;
  claimRsaNoMoreUnemployRights: boolean;
  claimRsaNoMoreUnemploy: boolean;
  claimRsaRefugeeClaimant: boolean;
  claimRsaOther: boolean;
  claimRsaOtherComment: string;

  isActive: boolean;
  activity: AssessmentActivity;
  unactivity: AssessmentUnactivity;

  accreditationSIAE: boolean;
  accreditationSIAEDate: Date;

  accreditationRQTH: boolean;
  accreditationRQTHDate: Date;

  accreditationAAH: boolean;
  accreditationAAHDate: Date;

  hasWorked: boolean;
  howLongHasWorked: AssessmentHowLongHasWorked;

  proExps: AssessmentProExpDto[] = [];

  searchingForJob: boolean;
  searchingForJobReasonNotTo: string;
  readyForNewJob: boolean;
  readyForNewJobReasonNotTo: string;
  jobCenterRegistration: AssessmentJobCenterRegistration;
  jobCenterLastUpdateDate: Date;
  integrationStepsTaken: string;

  degree: DisplayLabel;
  studyAbroad: boolean;
  degreeLabel: string;
  degreeGained: boolean;
  trainingAreas: DisplayLabel[];

  formations: AssessmentFormationDto[] = [];

  // *********************************************************************************************
  // * Social situation

  residentialStatus: ResidentialStatus;
  socialExclusion: boolean;
  indebtedness: boolean;

  assistance: boolean;
  assistedByConseiller: boolean;
  assistedByAssociation: boolean;
  assistedByTravailleurSocial: boolean;
  assistedByFamilleAmis: boolean;
  assistedByAutre: boolean;

  autonomousMobility: boolean;
  licenceB: boolean;
  tclSubscription: boolean;

  transportModes: AssessmentTransportModeDto[] = [];

  maxMobilityDistance: number;
  maxMobilityGoToWorkTime: number;

  // *********************************************************************************************
  // * Orientation

  hasProfessionnalProject: boolean;
  professionnalProjectDetails: string;

  jobSoughts: AssessmentJobSoughtDto[] = [];

  contractSearchType: AssessmentContractTypes;
  workingTime: AssessmentWorkingTime;

  accessToFormation: boolean;
  housing: boolean;
  health: boolean;
  famillyOrganisation: boolean;
  mobility: boolean;
  budgetManagement: boolean;
  frenchUnderstanding: boolean;
  readingWritingDifficulties: boolean;
  adminDifficulties: boolean;
  numericDifficulties: boolean;
  noDifficulties: boolean;
  expectationsRegardingRSA: string;

  // *********************************************************************************************
  // * Orientation

  supportProposal: AssessmentSupportProposal;
  supportAcceptance: boolean;
  dataSharingAcceptance: boolean;
  supportChoiceExplanation: string;
}
